/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Cell_Inherited_DisabledInputs */



/**
* | output |
* | --- |
* | "Organization default · disabled" |
*
* @param {Rights_Tools_Cell_Inherited_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_cell_inherited_disabled = /** @type {((inputs?: Rights_Tools_Cell_Inherited_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Cell_Inherited_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisationsstandard · deaktiviert")
	return /** @type {LocalizedString} */ ("Organization default · disabled")
});